import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import StaticPageRouter from '../../../components/StaticPage/Router';
import RoutesUtils from '../../../utils/routes';
import Utils from '../../../utils';
import { GalleryInfosState } from '../../Gallery/reducer';
import { AppInfosState } from '../../App/reducer';
import { AuthenticationUserState } from '../../Authentication/reducer';
import AuthUtils from '../../../utils/authentication';
import { DriveItemInfo, DriveListState, FetchStatus } from '../../DriveItemList/reducer';
import { Api } from '../../../typings/api';

const isGalleryLoaded = (galleryInfos: GalleryInfosState, appInfos: AppInfosState): boolean => {
	const { template, isConfigLoaded } = galleryInfos;
	const isTemplateLoaded = Utils.isTemplateLoaded(appInfos, galleryInfos);
	const isMenuLoaded = !!(template && template.menu);

	return isConfigLoaded && isTemplateLoaded && isMenuLoaded;
};

const needsConnection = (userInfos: AuthenticationUserState): boolean => {
	// Can only be true in secured galleries, not in Uprez app
	const { needCredentials, mode } = userInfos;
	return needCredentials && AuthUtils.isNotConnected(mode);
};

const hasFetchError = (driveList: DriveListState, component: string | undefined): boolean => {
	if (!component) {
		return false;
	}

	const fetchStatus = driveList.driveItemsFetchStatus[component] && driveList.driveItemsFetchStatus[component].metaFetchStatus;
	return fetchStatus === FetchStatus.ERROR;
};

const isNotComponent = (driveList: DriveListState, component: string | undefined): boolean => {
	if (!component) {
		return true;
	}

	const driveItem: DriveItemInfo | undefined = driveList.driveItems[component];
	if (!driveItem) {
		return false;
	}

	return driveItem.type !== Api.DriveItemType.Component;
};

const mapStateToProps = (state: StoreState) => {
	const {
		routerParamsHistory,
		galleryInfos,
		appInfos,
		driveList,
		authentication: {
			userInfos
		},
	} = state;
	const component: string | undefined = RoutesUtils.getCurrentRouterParam(routerParamsHistory).params.component;
	return {
		isGalleryLoaded: isGalleryLoaded(galleryInfos, appInfos),
		needsConnection: needsConnection(userInfos),
		hasFetchError: hasFetchError(driveList, component),
		isNotComponent: isNotComponent(driveList, component),
		component,
		driveList,
	};
};

export default connect(mapStateToProps)(StaticPageRouter);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/StaticPage/Router/index.tsx